<div class="container">
  <h2>{{ translationService.getChooseYourLocationText() }}</h2>

  <mat-form-field appearance="outline">
    <mat-label>{{ translationService.getSelectCountryText() }}</mat-label>
    <mat-select [(ngModel)]="selectedCountry">
      @for (country of countries; track country) {
        <mat-option [value]="country">
          {{ country }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  @if (isCanada()) {
    <mat-form-field appearance="outline">
      <mat-label>{{
        translationService.getSelectProvinceOrTerritoryText()
      }}</mat-label>
      <mat-select [(ngModel)]="selectedProvince">
        @for (province of provinces; track province) {
          <mat-option [value]="province.name">
            {{ province.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  }

  <div class="location-dialog-btn-container">
    <button
      mat-raised-button
      (click)="dialogRef.close()"
      type="button"
      color="accent"
    >
      {{ translationService.getCloseText() }}
    </button>
    <button
      mat-raised-button
      (click)="submitLocation()"
      type="button"
      color="accent"
      [disabled]="!selectedCountry"
    >
      {{ translationService.getSubmitText() }}
    </button>
  </div>
</div>
